import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';

import { ApiError } from '../../../../core';
import { IPeriodicidadeCompraFilter } from '../../../../domains/environment/periodicidade-compra/interfaces/periodicidade-compra-filter.interface';
import { PeriodicidadeCompraApi } from '../../../environment/periodicidade-compra/api/periodicidade-compra.api';
import { EnumSituacao } from '../../enums/situacao.enum';
import { CustomControlValueAccessor } from '../../utils/custom-control-value-accessor/custom-control-value-accessor';
import { IMultiSelectSettings } from '../multi-select/models/multi-select-settings.interface';
import { IOption } from '../multi-select/models/option.interface';
import { ToastService } from '../toast/services/toast.service';

@Component({
  selector: 'sgt-novo-periodicidade-compra-multi-select',
  templateUrl: './novo-periodicidade-compra-multi-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(
        () => NovoPeriodicidadeCompraMultiSelectComponent
      ),
      multi: true
    }
  ]
})
export class NovoPeriodicidadeCompraMultiSelectComponent extends CustomControlValueAccessor<
  number[]
> implements OnInit {
  @Input() idsPeriodicidades: number[];
  @Input() settings!: IMultiSelectSettings;
  @Output() search = new EventEmitter<number[]>();

  defaultSettings: IMultiSelectSettings = {
    placeholder: 'Periodicidades de compras',
    singular: 'Periodicidade de compra',
    plural: 'Periodicidades de compras',
    searchEmptyResultMessage: 'Nenhuma periodicidade de compra encontrada',
    showFooter: false
  };

  options: IOption[] = [];

  ngOnInit(): void {
    this.settings = { ...this.defaultSettings, ...this.settings };
  }

  private filter: IPeriodicidadeCompraFilter = {
    situacoes: EnumSituacao.ATIVO,
  };

  constructor(
    private toastService: ToastService,
    private periodicidadeCompraApi: PeriodicidadeCompraApi
  ) {
    super();
  }

  firstOpened(isFirstOpened: boolean): void {
    if (isFirstOpened && this.options.length === 0) {
      this.load();
    }
  }

  private load(): void {
    this.definirCarregando(true);

    this.periodicidadeCompraApi
      .fetchPeriodicidadesComprasList(this.filter)
      .pipe(take(1), finalize(() => this.definirCarregando(false)))
      .subscribe({
        next: (response) => {
          const currentIds = this.value ?? [];
          this.options = response.data.map((item) => ({
            id: item.id,
            label: item.nome,
            isChecked: currentIds.includes(item.id)
          }));
        },
        error: (err: ApiError) => {
          this.toastService.error(err.message, {
            title: err.cause || 'Aconteceu algo inesperado.',
            duration: 5000
          });
        }
      });
  }

  protected updateValue(newValue: number[] | null): void {
    const ids = newValue ?? [];
    if (ids.length > 0 && this.options.length === 0) {
      this.load();
      return;
    }
    if (this.options.length > 0) {
      this.options.forEach((o) => {
        o.isChecked = ids.includes(o.id);
      });
    }
  }

  onSearch(): void {
    this.search.emit(this.idsPeriodicidades);
  }

  onSelectionChange(): void {
    this.emitChange(this.idsPeriodicidades);
    this.markAsTouched();
  }

  private definirCarregando(carregando: boolean): void {
    this.settings = { ...this.settings, isLoading: carregando };
  }

}
